import { SearchInput } from '@app/components/ui/Search/input.search'

type TopicLandingToolbarProps = {
  count: number
  search: string
  mainTopic?: string
  onSearchChange: (value: string) => void
}

export const TopicLandingToolbar = ({
  count,
  search,
  mainTopic,
  onSearchChange,
}: TopicLandingToolbarProps) => {
  return (
    <div className="mb-4 flex items-center justify-between gap-4">
      <p className="text-sm text-muted-foreground">
        {count} {count === 1 ? 'item' : 'items'}
      </p>

      <SearchInput
        value={search}
        onChange={onSearchChange}
        items={[]}
        minLength={1}
        getItemKey={(item) => String(item)}
        onSelectItem={() => undefined}
        renderItem={() => null}
        placeholder={`Search ${mainTopic}...`}
        size="small"
        onClear={() => onSearchChange('')}
      />
    </div>
  )
}
